import * as React from 'react';

import { progressoDoFunil, type ProgressoFunil } from '@/etapas';

import { useIntegrador } from './use-integrador';
import { useProjetoAtual } from './use-projeto';

/* O progresso real do funil: o que já está resolvido no BANCO, não o quanto a
 * pessoa navegou.
 *
 * Fica aqui, e não dentro do componente da trilha, pela regra da camada de
 * dados: componente não faz fetch. E fica separado de `etapas.ts` porque a
 * regra do funil é pura e testável sem React, enquanto isto é só a plumbagem
 * que entrega os dados a ela.
 *
 * As duas consultas já estão em cache em qualquer tela do funil (a faixa da
 * empresa e as próprias telas as pedem), então isto não acrescenta requisição
 * nenhuma: é a mesma chave do React Query.
 *
 * `carregando` é exposto separado do progresso de propósito. Enquanto a
 * resposta não chega, TUDO parece não resolvido — e uma trilha que pisca
 * "nada feito" a cada troca de tela apaga o único sinal que ela existe para
 * dar. Quem desenha usa isto para segurar o estado anterior. */
export function useProgresso(atual?: string): { progresso: ProgressoFunil; carregando: boolean } {
  const integrador = useIntegrador();
  const projeto = useProjetoAtual();

  const progresso = React.useMemo(
    () => progressoDoFunil({ integrador: integrador.data, projeto: projeto.data }, atual),
    [integrador.data, projeto.data, atual],
  );

  return { progresso, carregando: integrador.isPending || projeto.isPending };
}
